// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/background_chessboard.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/chevron-right.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/chevron-left.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../assets/hint.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../assets/hint_active.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
}

a {
  text-decoration: none;
}

p {
  font-size: 1rem;
}
@media (min-width: 768px) {
  p {
    font-size: 2rem;
  }
}

h2 {
  font-size: 1.5rem;
}
@media (min-width: 768px) {
  h2 {
    font-size: 3rem;
  }
}

h3 {
  font-size: 1.25rem;
}
@media (min-width: 768px) {
  h3 {
    font-size: 2rem;
  }
}

.board-container {
  margin: 0 5vw;
  width: 90vw;
  height: 90vw;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  border-radius: 24px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);
}
@media (min-width: 768px) {
  .board-container {
    margin: 0 2.25rem;
  }
}
@media (min-width: 1280px) {
  .board-container {
    margin: 0 calc(25rem + (100vw - 1280px) / 2);
    height: 30rem;
    width: 30rem;
  }
}

body {
  background-color: rgb(240, 217, 181);
}

.navbutton {
  background-color: rgba(0, 0, 0, 0);
  border: none;
  outline: none;
  width: 2rem;
  height: 2rem;
  background-repeat: no-repeat;
  background-size: cover;
}
@media (min-width: 768px) {
  .navbutton {
    width: 3rem;
    height: 3rem;
  }
}
.navbutton--forward {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  margin-left: auto;
}
.navbutton--backward {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.navbutton--hint {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.navbutton--hintactive {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.navbutton--hide {
  background-image: none;
}

.navpanel {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0 1rem;
}
@media (min-width: 768px) {
  .navpanel {
    margin: 0 2.25rem;
  }
}
@media (min-width: 1280px) {
  .navpanel {
    margin: 0 calc(25rem + (100vw - 1280px) / 2);
  }
}
.navpanel__title {
  margin-left: 1rem;
}
.navpanel__title--hide {
  opacity: 0;
}`, "",{"version":3,"sources":["webpack://./src/styles/_partials.scss","webpack://./src/pages/PuzzlePage.scss"],"names":[],"mappings":"AAiBA;EACE,sBAAA;AChBF;;AD8BA;EACE,qBAAA;AC3BF;;AD6BA;EACE,eAAA;AC1BF;ADJE;EA6BF;IAGI,eAAA;ECxBF;AACF;;AD0BA;EACE,iBAAA;ACvBF;ADbE;EAmCF;IAGI,eAAA;ECrBF;AACF;;ADuBA;EACE,kBAAA;ACpBF;ADtBE;EAyCF;IAGI,eAAA;EClBF;AACF;;AA/BA;EACI,aAAA;EACA,WAAA;EACA,YAAA;EACA,yDAAA;EACA,2BAAA;EACA,4BAAA;EACA,wBAAA;EACA,mBAAA;EACA,yCAAA;AAkCJ;ADvCE;ECJF;IAWQ,iBAAA;EAoCN;AACF;ADtCE;ECVF;IAcQ,4CAAA;IACA,aAAA;IACA,YAAA;EAsCN;AACF;;AAjCA;EACI,oCDvBU;AC2Dd;;AAlCA;EACI,kCAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,4BAAA;EACA,sBAAA;AAqCJ;ADjEE;ECqBF;IASQ,WAAA;IACA,YAAA;EAuCN;AACF;AAtCI;EACI,yDAAA;EACA,iBAAA;AAwCR;AAtCI;EACI,yDAAA;AAwCR;AAtCI;EACI,yDAAA;AAwCR;AAtCI;EACI,yDAAA;AAwCR;AAtCI;EACI,sBAAA;AAwCR;;AApCA;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;AAuCJ;AD9FE;ECmDF;IAMQ,iBAAA;EAyCN;AACF;AD7FE;EC6CF;IASQ,4CAAA;EA2CN;AACF;AA1CI;EACI,iBAAA;AA4CR;AA3CQ;EACI,UAAA;AA6CZ","sourcesContent":["//Colors\n$square-dark:rgb(181, 136,99);\n$square-light:rgb(240, 217,181);\n$tablet-breakpoint: 768px;\n$desktop-breakpoint: 1280px;\n@mixin tablet {\n  @media (min-width: $tablet-breakpoint) {\n    @content;\n  }\n}\n\n@mixin desktop {\n  @media (min-width: $desktop-breakpoint) {\n    @content;\n  }\n}\n\n*{\n  box-sizing: border-box;\n}\n//Margins for these pages are consistent, so they're defined here as variables.\n$mobile-indent: 1rem;\n$tablet-indent: 2.25rem;\n\n//This needs to change based on the width of the window.\n//We get the width with 100vw, find how much larger the window is than our desktop breakpoint,\n//then divide it by 2 so that the indent can be applied to both sides.\n$base-desktop-indent: 25rem;\n$desktop-indent: calc(\n  $base-desktop-indent + ((1vw * 100) - $desktop-breakpoint) / 2\n);\n\na {\n  text-decoration: none;\n}\np{\n  font-size: 1rem;\n  @include tablet{\n    font-size: 2rem;\n  }\n}\nh2{\n  font-size: 1.5rem;\n  @include tablet{\n    font-size: 3rem;\n  }\n}\nh3{\n  font-size: 1.25rem;\n  @include tablet{\n    font-size: 2rem;\n  }\n}","@use \"../styles/partials\" as *;\n\n.board-container{\n    margin: 0 5vw;\n    width: 90vw;\n    height: 90vw;\n    background-image: url(\"../assets/background_chessboard.svg\");\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: contain;\n    border-radius: 24px;\n    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);\n    @include tablet{\n        margin: 0 $tablet-indent;\n    }\n    @include desktop{\n        margin: 0 $desktop-indent;\n        height:30rem;\n        width:30rem;\n    }\n    \n}\n\n\nbody{\n    background-color: $square-light;\n}\n.navbutton{\n    background-color: rgba(#000000,  0);\n    border:none;\n    outline:none;\n    width: 2rem;\n    height:2rem;\n    background-repeat: no-repeat;\n    background-size: cover;\n    @include tablet{\n        width:3rem;\n        height:3rem;\n    }\n    &--forward{\n        background-image: url('../assets/chevron-right.svg');\n        margin-left:auto;\n    }\n    &--backward{\n        background-image: url('../assets/chevron-left.svg');\n    }\n    &--hint{\n        background-image: url('../assets/hint.svg');\n    }\n    &--hintactive{\n        background-image: url('../assets/hint_active.svg');\n    }\n    &--hide{\n        background-image: none;\n    }\n}\n\n.navpanel{\n    display:flex;\n    flex-direction: row;\n    align-items: center;\n    margin: 0 $mobile-indent;\n    @include tablet{\n        margin: 0 $tablet-indent;\n    }\n    @include desktop{\n        margin: 0 $desktop-indent;\n    }\n    &__title{\n        margin-left: 1rem;\n        &--hide{\n            opacity: 0;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
